var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { utils } from 'ethers';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box, SkeletonCircle, SkeletonRectangle, Text } from '..';
var DECIMAL_REGEX = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/;
var Input = styled.input(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: transparent;\n  font-size: 22px;\n  width: 100%;\n  font-family: Matter;\n  border: 0;\n  color: #ffffff;\n  text-align: right;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  background-color: transparent;\n  font-size: 22px;\n  width: 100%;\n  font-family: Matter;\n  border: 0;\n  color: #ffffff;\n  text-align: right;\n\n  &:focus {\n    outline: none;\n  }\n"])));
var InputContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #ffffff10;\n  border: 1px solid #ffffff20;\n  padding: 12px 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 13px;\n"], ["\n  background-color: #ffffff10;\n  border: 1px solid #ffffff20;\n  padding: 12px 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 13px;\n"])));
var NumberInputSkeleton = function () { return (_jsxs(InputContainer, { children: [_jsx(Box, __assign({ width: "30px", height: "30px", borderRadius: "15px", marginRight: "10px" }, { children: _jsx(SkeletonCircle, { style: { width: '30px', height: '30px', borderRadius: '15px' } }, void 0) }), void 0), _jsx(SkeletonRectangle, { width: "50px" }, void 0), _jsx(Input, { placeholder: "0.0", type: "number" }, void 0)] }, void 0)); };
export var NumberInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, tokenSymbol = _a.tokenSymbol, tokenIconUrl = _a.tokenIconUrl, placeholder = _a.placeholder, loading = _a.loading, disabled = _a.disabled, decimals = _a.decimals;
    var _b = useState(''), shownValue = _b[0], setShownValue = _b[1];
    useEffect(function () {
        if (disabled || loading || (!value && !shownValue))
            return;
        if (!value) {
            setShownValue('');
        }
        else if (!shownValue || !utils.parseUnits(formatShownValue(shownValue), decimals).eq(value)) {
            setShownValue(utils.formatUnits(value, decimals));
        }
    }, [value, decimals, shownValue, disabled, loading]);
    if (loading)
        return _jsx(NumberInputSkeleton, {}, void 0);
    return (_jsxs(InputContainer, { children: [tokenIconUrl && _jsx("img", { src: tokenIconUrl, width: 30, style: { marginRight: '10px' } }, void 0), tokenSymbol && (_jsx(Text, __assign({ style: { paddingRight: '8px' }, weight: "regular", size: "m" }, { children: tokenSymbol }), void 0)), _jsx(Input, { disabled: disabled || loading, onPaste: function (e) {
                    if (!e.clipboardData.getData('Text').match(DECIMAL_REGEX))
                        e.preventDefault();
                }, onKeyPress: function (e) {
                    if (!(shownValue + e.key).match(DECIMAL_REGEX))
                        e.preventDefault();
                }, placeholder: placeholder, value: shownValue, onChange: function (e) {
                    var value = e.currentTarget.value;
                    if (value === '') {
                        onChange && onChange(undefined);
                        setShownValue(value);
                        return;
                    }
                    var newValue;
                    try {
                        var formattedShownValue = formatShownValue(value);
                        newValue = utils.parseUnits(formattedShownValue, decimals);
                    }
                    catch (e) {
                        // don't update the input on invalid values
                        return;
                    }
                    onChange && onChange(newValue);
                    setShownValue(value);
                }, type: "text" }, void 0)] }, void 0));
};
function formatShownValue(value) {
    var splittedValue = value.split('.');
    var wholePart = splittedValue[0];
    if (splittedValue.length === 1) {
        return wholePart;
    }
    else {
        return value;
    }
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=NumberInput.js.map